/**
 * Extracts a readable error message from an API error object.
 *
 * @param {Object} error - The caught error object from Axios/Fetch
 * @param {String} defaultMessage - Fallback message if no specific error is found
 * @returns {String} - The formatted error message
 */
export function getErrorMessage(error, defaultMessage = "Please check your inputs and try again.") {
    const apiErrors = error?.response?.data?.errors;
    const apiMessage = error?.response?.data?.message;

    if (typeof apiErrors === 'string') {
        return apiErrors;
    }

    if (typeof apiErrors === 'object' && apiErrors !== null) {
        return Object.values(apiErrors).flat().join('\n');
    }

    if (apiMessage) {
        return apiMessage;
    }

    if (error?.message) {
        return error.message;
    }

    return defaultMessage;
}